import { request } from '../utils/request';
import { formatSources } from '../utils/sourcesHelper';

const getHistoryMeta = async (token, num_days_history) => {
	const response = await request({
		method: 'GET',
		url: '/ai/rag/conversation/meta?daysFrom=' + num_days_history,
		token,
	});

	return response;
};

const getConversation = async (token, conversation_id) => {
	const response = await request({
		method: 'GET',
		url: '/ai/rag/conversation/' + conversation_id,
		token,
	});

	if (response?.conversation?.messages.length > 0) {
		// Form real links for the sources
		const formattedReferences = formatSources(response.conversation.messages[0].sources);
		response.conversation.messages[0].sources = formattedReferences;

		if (response.conversation.messages.length > 1) {
			// Form real links for the sources
			const formattedReferences = formatSources(response.conversation.messages[1].sources);
			response.conversation.messages[1].sources = formattedReferences;
		}
	}

	return response;
};

const muteConversation = async (conversationId) => {
	const response = await request({
		method: 'PUT',
		url: '/ai/rag/conversation/' + conversationId + '/visibility',
		data: {
			hide: true,
		},
	});

	if (!response.errorCode) {
		return response;
	} else {
		return false;
	}
};

const changeConversationLabel = async (conversationId, label) => {
	const response = await request({
		method: 'PUT',
		url: '/ai/rag/conversation/' + conversationId + '/label',
		data: {
			label: label,
		},
	});

	if (!response.errorCode) {
		return response;
	} else {
		return false;
	}
};

const getFeedback = async (token, conversation_id) => {
	const response = await request({
		method: 'GET',
		url: '/ai/rag/conversation/' + conversation_id + '/feedback',
		token,
	});

	return response;
};

const sendFeedback = async (token, conversation_id, positive, comment) => {
	const response = await request({
		method: 'POST',
		url: '/ai/rag/conversation/' + conversation_id + '/feedback',
		data: {
			comment: comment,
			positive: positive,
		},
		token,
	});

	return response;
};

export { getFeedback, sendFeedback, getHistoryMeta, getConversation, muteConversation, changeConversationLabel };
